import { render, staticRenderFns } from "./Uploadvideo.vue?vue&type=template&id=682bc47f&"
import script from "./Uploadvideo.vue?vue&type=script&lang=js&"
export * from "./Uploadvideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports